// Generated by ReScript, PLEASE EDIT WITH CARE


var tabs_0 = {
  tabId: /* ApprovedPriorities */0,
  label: {
    TAG: /* Text */0,
    _0: "Approved Priorities"
  },
  icon: null,
  disabled: false,
  tooltip: undefined
};

var tabs_1 = {
  hd: {
    tabId: /* PendingPriorities */1,
    label: {
      TAG: /* Text */0,
      _0: "Pending Priorities"
    },
    icon: null,
    disabled: false,
    tooltip: undefined
  },
  tl: /* [] */0
};

var tabs = {
  hd: tabs_0,
  tl: tabs_1
};

export {
  tabs ,
  
}
/* tabs Not a pure module */
